// extracted by mini-css-extract-plugin
export default {"LayoutContainer":"📚19-10-2XzrMj","disabled":"📚19-10-2fXqtS","ControlAligner":"📚19-10-2_LnFO"};